import { AfterViewInit, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-book-demo',
  imports: [RouterLink],
  templateUrl: './book-demo.html',
  styleUrl: './book-demo.scss',
})
export class BookDemo implements AfterViewInit {
  /** Arrived from the SHOUT+ intro (?product=shout-plus): show the SHOUT+ branded page. */
  protected readonly shoutPlus = inject(ActivatedRoute).snapshot.queryParamMap.get('product') === 'shout-plus';

  ngAfterViewInit(): void {
    this.loadMeetingsScript();
  }

  loadMeetingsScript(): void {
    const hubspotWindow = window as Window & {
      hbspt?: { widgets?: { load: () => void } };
    };
    hubspotWindow.hbspt?.widgets?.load();

    const existingScript = document.querySelector('script[src*="MeetingsEmbedCode.js"]');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    script.async = true;
    document.body.appendChild(script);
  }
}
